<template>

    <el-row>
        <el-col :span="18" :push="3">
            <div class="box">
                <dash-board-item class="dash-item" :data="data"></dash-board-item>
                <dash-board-item class="dash-item" :data="data"></dash-board-item>
            </div>
        </el-col>
    </el-row>

</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>

    import DashBoardItem from '../../components/DashBoardItem'

    export default {
        name: 'DashBoard',
        components: {DashBoardItem},
        data() {
            return {
                data: {
                    title: 'China',
                    booking: 1,
                    form: 1,
                    feedBack: 1,
                    checklist: 1

                }
            }
        }
    }
</script>

<style scoped>
    .box {
        display: flex;
        flex-wrap: wrap;
    }

    .dash-item {
        margin: 0 2% 2% 0;
    }
</style>
